const cards = [
  {
    title: "某顶流男星私生活混乱：多位当事人实名爆料",
    excerpt: "三名自称与该男星有过亲密关系的女性联合发声，披露其同时交往多人、利用明星身份施压封口等细节。",
    date: "2026-07-29",
    img: "https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20person%20against%20bright%20city%20lights%2C%20anonymous%20figure%2C%20dramatic%20backlight%2C%20mysterious%20atmosphere%2C%20film%20noir%20portrait%20style%2C%20deep%20shadows%2C%20warm%20amber%20rim%20light&width=800&height=500&seq=cards-01&orientation=landscape",
    category: "明星黑料",
    views: "48,392",
  },
  {
    title: "头部主播带货翻车：消费者集体维权最新进展",
    excerpt: "数百名消费者联合起诉某头部带货主播虚假宣传，涉案金额超千万，目前已进入司法程序。",
    date: "2026-07-28",
    img: "https://readdy.ai/api/search-image?query=Protest%20scene%20with%20signs%20in%20dark%20urban%20setting%2C%20dramatic%20night%20photography%2C%20crowd%20silhouettes%2C%20moody%20atmosphere%2C%20documentary%20style%2C%20warm%20street%20light%20contrast&width=800&height=500&seq=cards-02&orientation=landscape",
    category: "带货打假",
    views: "36,715",
  },
  {
    title: "综艺选秀节目投票系统漏洞：技术人员独家揭秘",
    excerpt: "前节目组技术人员匿名爆料，详述投票系统后台如何通过权重算法操控最终排名。",
    date: "2026-07-27",
    img: "https://readdy.ai/api/search-image?query=Computer%20server%20room%20with%20blinking%20lights%20in%20darkness%2C%20mysterious%20tech%20environment%2C%20dramatic%20blue-red%20contrast%20lighting%2C%20cyber%20aesthetic%2C%20moody%20atmosphere&width=800&height=500&seq=cards-03&orientation=landscape",
    category: "综艺内幕",
    views: "52,841",
  },
  {
    title: "某知名女星涉嫌税务问题：工作室已注销引猜测",
    excerpt: "企业信息查询显示该女星名下多家工作室近期集中注销，时间点与此前税务稽查传闻高度吻合。",
    date: "2026-07-26",
    img: "https://readdy.ai/api/search-image?query=Empty%20luxurious%20office%20with%20dark%20furniture%2C%20papers%20scattered%2C%20abandoned%20workspace%2C%20dramatic%20natural%20light%20from%20window%2C%20moody%20atmosphere%2C%20investigative%20photography&width=800&height=500&seq=cards-04&orientation=landscape",
    category: "明星黑料",
    views: "41,208",
  },
  {
    title: "网红情侣互撕升级：双方晒聊天记录实锤不断",
    excerpt: "从恩爱秀到互撕仅用三天，两人先后放出大量私密聊天记录，涉及金钱纠纷与第三者插足。",
    date: "2026-07-25",
    img: "https://readdy.ai/api/search-image?query=Broken%20phone%20screen%20displaying%20messages%20on%20dark%20surface%2C%20dramatic%20closeup%2C%20moody%20lighting%2C%20emotional%20conflict%20metaphor%2C%20warm%20amber%20accent%2C%20film%20noir%20style&width=800&height=500&seq=cards-05&orientation=landscape",
    category: "感情纠纷",
    views: "67,934",
  },
  {
    title: "品牌代言虚假宣传被实锤：涉及多位一线艺人",
    excerpt: "市场监管部门对某品牌虚假宣传立案调查，曾为其背书的五位艺人被要求配合调查。",
    date: "2026-07-24",
    img: "https://readdy.ai/api/search-image?query=Luxury%20brand%20store%20with%20closed%20shutters%20at%20night%2C%20dramatic%20street%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20amber%20glow%2C%20urban%20night%20scene%2C%20cinematic%20photography&width=800&height=500&seq=cards-06&orientation=landscape",
    category: "品牌虚假宣传",
    views: "39,156",
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          深度猛料
        </h2>
        <div className="w-16 h-1 bg-primary-500 mx-auto mb-10 rounded-full"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-colors group cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded text-xs font-semibold bg-primary-500/15 text-primary-400 mb-3 whitespace-nowrap">
                  {card.category}
                </span>
                <h3 className="font-heading text-foreground-200 text-sm mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-foreground-600 text-xs">
                  <span>{card.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}